require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-are-world-bank-social-protection-projects-including.json") })
        }
      }, "path---en-us-update-how-are-world-bank-social-protection-projects-including");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-are-world-bank-social-protection-projects-including!./.cache/json/en-us-update-how-are-world-bank-social-protection-projects-including.json
// module id = 677
// module chunks = 231608221292675